












import { Image } from 'vant';
import { Component, Prop, Vue } from "vue-property-decorator";

Vue.use(Image);

@Component({})
export default class PageResult extends Vue {
    @Prop()
    icon!:any;

    @Prop(String) 
    msg?: string;

    created() {
        
    }

    mounted() {
        
    }
}
